import {
  DepartmentUserSlice,
  OrganizationUsersSliceStateType,
  OrganizationsSliceActionsType,
  createOrganizationUser,
  reassignOrganizationUser,
  loadOrganizationUsers,
  updateOrganizationUser,
  partialUpdateOrganizationUser,
} from 'src/store/organizationAdmin/organizationUsersSlice';
import { useAppDispatch, useAppSelector } from 'src/hooks/useRedux';
import getFetchStatus from 'src/utils/fetchStatus';
import { CreateOrganizationUserFormData } from 'src/forms/createOrganizationUser';
import {
  IndexParams,
  ReassignParams,
  PatchParams,
  UpdateParams,
} from 'src/repositories/organizationAdmin/OrganizationUsersRepository';

type UseOrganizationsUsersType = Pick<
  OrganizationUsersSliceStateType,
  'meta' | 'organizationUsers' | 'departmentsUsers'
> &
  OrganizationsSliceActionsType & {
    isOrganizationUsersLoadFinished: boolean;
    getUsersByDepartmentId: (id: number) => DepartmentUserSlice;
  };

const useOrganizationsUsers = (): UseOrganizationsUsersType => {
  const dispatch = useAppDispatch();
  const {
    meta,
    organizationUsers,
    departmentsUsers,
    index: { fetchStatus: organizationsIndexFetchStatus },
  } = useAppSelector(state => state.organizationAdminOrganizationUsers);

  const isOrganizationUsersLoadFinished = getFetchStatus(organizationsIndexFetchStatus).isFinished;
  const getUsersByDepartmentId = (id: number) => departmentsUsers[id] || ({} as DepartmentUserSlice);

  return {
    meta,
    organizationUsers,
    departmentsUsers,
    isOrganizationUsersLoadFinished,
    getUsersByDepartmentId,
    loadOrganizationUsers: (params?: IndexParams) => dispatch(loadOrganizationUsers(params)),
    createOrganizationUser: (params: CreateOrganizationUserFormData) => dispatch(createOrganizationUser(params)),
    reassignOrganizationUser: (params: ReassignParams) => dispatch(reassignOrganizationUser(params)),
    updateOrganizationUser: (params: UpdateParams) => dispatch(updateOrganizationUser(params)),
    partialUpdateOrganizationUser: (params: PatchParams) => dispatch(partialUpdateOrganizationUser(params)),
  };
};

export default useOrganizationsUsers;
